function Validator_date(element) {
  this.$element = $(element);

  this.selectors = {
    formParent: 'form[data-i4-decorator="Validator_form"]'
  };

  this.data = {
    required: 'required',
    messageFail: 'message-fail',
    future: 'future',
    notBeforeToday: 'not-before-today'
  };

  this.triggers = {
    validate: 'i4:validate',
    updateView: 'i4:updateView',
    refresh: 'i4:refresh'
  };

  this.classNames = {
    failMessage: 'fail-message',
    validateOnSubmit: 'validate-on-submit'
  };

  this.init = function () {

    // console.log('init - date');

    this.$formParent = this.$element.parents(this.selectors.formParent);
    this.dataRequired = this.$element.data(this.data.required);
    this.dataMessageFail = this.$element.data(this.data.messageFail);

    this.dataFuture = this.$element.data(this.data.future);
    this.dataNotBeforeToday = this.$element.data(this.data.notBeforeToday);

    this.$formParent.trigger(this.triggers.refresh);

    this.$element.on(this.triggers.validate, this.validate.bind(this));
    this.$element.on('keyup blur focus', this.$elementChange.bind(this));

    this.validateOnSubmit = this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit);
    this.prepareFailMessage();

    if (!this.validateOnSubmit) {
      this.validate();
    }

  };

  this.$elementChange = function () {
    this.validate();

    this.$formParent.trigger(this.triggers.updateView);
  };

  this.validate = function () {
    this.value = this.$element.val();

    var isValid = i4_Validator.isValidDate(this.value, {
      future: this.dataFuture,
      notBeforeToday: this.dataNotBeforeToday
    });

    var dataRequired = this.$element.attr('data-required');

    this.$element.removeClass('invalid');
    this.$element.removeClass('valid');
    this.$failMessage.hide();

    if (isValid) {
      this.$element.addClass('valid');
    } else if (isValid == false && dataRequired == 1) {
      this.$element.addClass('invalid');

      if (this.validateOnSubmit || this.value != '') {
        this.$failMessage.show();
      } else {
        this.$failMessage.hide();
      }
    }
  };

  this.prepareFailMessage = function () {
    this.$failMessage = $('<div></div>');

    if (this.dataMessageFail !== undefined) {
      this.$failMessage.
      addClass(this.classNames.failMessage).
      html(this.dataMessageFail).
      hide();

      this.$element.parent().append(this.$failMessage);
    }
  };

}
